"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = function useStyles(_ref) {
  var type = _ref.type,
    isCollapsible = _ref.isCollapsible;
  var flagColor = 'NEUTRAL100';
  if (type === 'info') {
    flagColor = 'BLUE400';
  } else if (type === 'danger') {
    flagColor = 'RED400';
  } else if (type === 'success') {
    flagColor = 'GREEN400';
  } else if (type === 'warning') {
    flagColor = 'YELLOW200';
  }
  return (0, _styles.makeStyles)(function (theme) {
    return {
      banner: {
        backgroundColor: theme.palette.NEUTRAL000,
        boxShadow: theme.shadows[1],
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderRadius: 4,
        transition: 'all 0.2s ease',
        '&:focus-visible': {
          outline: 'none'
        }
      },
      bannerCollapsible: {
        '&:hover': {
          backgroundColor: theme.palette.NEUTRAL010,
          boxShadow: theme.shadows[2]
        },
        '&:focus-visible': {
          boxShadow: "0 0 0 2px ".concat(theme.palette.BLUE400),
          outline: 'none'
        }
      },
      borderLeft: {
        borderLeft: "4px solid ".concat(theme.palette[flagColor])
      },
      borderTop: {
        borderTop: "4px solid ".concat(theme.palette[flagColor])
      },
      header: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: isCollapsible ? 'pointer' : 'default',
        padding: theme.spacing(2, 2),
        '&:hover': {
          backgroundColor: isCollapsible ? theme.palette.NEUTRAL010 : 'transparent'
        }
      },
      headerStart: {
        display: 'flex',
        alignItems: 'center'
      },
      icon: {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette[flagColor],
        marginRight: theme.spacing(1),
        display: 'flex',
        position: 'relative',
        '&::before': {
          content: "''",
          width: 12,
          height: 12,
          backgroundColor: type === 'warning' ? theme.palette.NEUTRAL900 : 'transparent',
          position: 'absolute',
          zIndex: 0,
          left: 2,
          top: 2,
          borderRadius: 4
        },
        '& svg': {
          position: 'relative'
        }
      },
      title: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 700,
        color: theme.palette.NEUTRAL800
      },
      body: {
        paddingRight: theme.spacing(5),
        paddingLeft: theme.spacing(5),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(2),
        fontWeight: 400,
        fontSize: theme.typography.pxToRem(14),
        lineHeight: '1.5',
        color: theme.palette.NEUTRAL800
      },
      collapseIcon: {
        display: 'flex',
        color: theme.palette.NEUTRAL900,
        fontSize: theme.typography.pxToRem(24)
      }
    };
  })();
};
var _default = useStyles;
exports.default = _default;